import '.l6{list-style:none;}.ssr-plugin'
import '.l7{padding-left:0px;}.ssr-plugin'
import '.l8{counter-reset:step-counter;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.dy{gap:2rem;}.ssr-plugin'
import { InfoAlert } from '@app/components/core/alert/InfoAlert'
import { Text } from '@app/components/core/typography/Text'
import Column from '@app/components/layout/Column'
import { styled } from 'inlines'
import { SectionHeader } from '../blocks/SectionHeader'
import { AppearItem, useAppearStyle } from '../blocks/AppearInViewport'

export type StepSectionItem = { content: string; alert?: string }
export type StepSectionType = {
  type: 'steps'
  title: string
  listItems: StepSectionItem[]
}

export const StepsContentSection = ({
  title,
  listItems,
}: StepSectionType & {
  index?: number
}) => {
  return (
    <Column>
      {title && (
        <AppearItem staggerIndex={0}>
          <SectionHeader title={title} />
        </AppearItem>
      )}
      <ol className="l6 l7 l8 d e dy"
      >
        {listItems?.map((step, stepIndex) => (
          <StepListItem key={stepIndex} step={step} staggerIndex={stepIndex + 1} />
        ))}
      </ol>
    </Column>
  )
}

const StepListItem = ({
  step,
  staggerIndex,
}: {
  step: StepSectionItem
  staggerIndex: number
}) => {
  const appearStyle = useAppearStyle(staggerIndex)

  return (
    <styled.li
      style={{
        ...appearStyle,
        '&::before': {
          counterIncrement: 'step-counter',
          content: 'counter(step-counter) "."',
          color: 'var(--brand-secondary)',
          fontFamily: 'FunnelDisplay',
          fontWeight: '700',
          fontStyle: 'normal',
          fontSize: '1.75rem',
          lineHeight: '100%',
          paddingRight: '1rem',
        },
      }}
    >
      <Text.Medium style={{ display: 'inline' }}>{step.content}</Text.Medium>
      {step.alert && (
        <InfoAlert message={step.alert} style={{ marginTop: '1rem' }} />
      )}
    </styled.li>
  )
}
